// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const combusken: PokeData = {
  "id": 256,
  "name": "combusken",
  "height": 9,
  "weight": 195,
  "base_experience": 142,
  "types": [
    PokeType.FIRE,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "scratch",
    "double-kick",
    "sand-attack",
    "growl",
    "ember",
    "flamethrower",
    "peck",
    "quick-attack",
    "focus-energy",
    "mirror-move",
    "slash",
    "reversal",
    "detect",
    "feather-dance",
    "blaze-kick",
    "sky-uppercut",
    "aerial-ace",
    "bulk-up",
    "bounce",
    "flare-blitz",
    "flame-charge"
  ],
  "moves": [
    "scratch",
    "double-kick",
    "growl",
    "ember",
    "flamethrower",
    "peck",
    "quick-attack",
    "blaze-kick",
    "aerial-ace",
    "bulk-up",
    "flare-blitz",
    "karate-chop",
    "jump-kick"
  ],
  "evolution_chain": {
    "id": 131,
    "item": null,
    "species": [
      {
        "name": "torchic",
        "order": 280,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "combusken",
        "order": 281,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 255,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "blaziken",
        "order": 282,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 256,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 55,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
